import { data } from '../data';
import { formatNumber } from './formatNumber';

export const formatCurrency = (number: number) => `${data.currency_symbol}${formatNumber(number)}`;
